// import React, { useRef, useState, useEffect } from "react";
import React, { useEffect } from "react";
import "../styles/tour-details.css";
// import { Container, Row, Col, Form, ListGroup } from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import tourData from "../assets/data/tours";
import calculateAvgRating from "../utils/avgRating";
import Booking from "../components/Booking/Booking";
import Newsletter from './../shared/Newsletter'

const TourDetails = () => {

  useEffect(() => {
    // Create a script element for the ElfSight widget
    const script = document.createElement("script");
    script.src =
      "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;

    // Append the script element to the body
    document.body.appendChild(script);

    // Clean up by removing the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const { id } = useParams();

  // const reviewMsgRef = useRef("");
  // const [tourRating, setTourRating] = useState(null);

  const tour = tourData.find((tour) => tour.id === id);

  const {
    photo,
    title,
    desc,
    address,
    // reviews,
    city,
    distance,
    details,
    maxGroupSize,
    image,
  } = tour;

  // const { totalRating, avgRating } = calculateAvgRating(reviews);

  // const options = { day: "numeric", month: "long", year: "numeric" };

  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   const reviewText = reviewMsgRef.current.value;

  //   alert(`${reviewText}, ${tourRating}`);
  // };

  return (
    <>
    <div className="centered-title">
      <h2>{title}</h2>
      </div>
      <section>
        <Container>
          <Row>
            <Col lg="8">
              <div className="tour__content">
                <img src={photo} alt="" />

                <div className="tour__info">

                  <div className="d-flex align-items-center gap-5">
                    {/* <span className="tour__rating d-flex align-items-center gap-1">
                      <i
                        class="ri-star-fill"
                        style={{ color: "var(--secondary-color)" }}
                      ></i>{" "}
                      {avgRating === 0 ? null : avgRating}
                      {totalRating === 0 ? (
                        "Not rated"
                      ) : (
                        <span>({reviews?.length})</span>
                      )}
                    </span> */}

                    <span>
                      <i class="ri-map-pin-line"></i> {address}
                    </span>
                  </div>
                  <div className="tour__extra-details">
                    <span>
                      <i class="ri-map-pin-line"></i> {city}
                    </span>
                    {/* <span>
                      <i class="ri-money-dollar-circle-line"></i> ₹ {price}
                      /person
                    </span> */}
                    <span>
                      <i class="ri-map-pin-time-line"></i> {distance} k/m
                    </span>
                    <span>
                      <i class="ri-group-line"></i> {maxGroupSize} people
                    </span>
                  </div>
                  <h5>Description</h5>
                  <p>{desc}</p>
                  <h5>Details About The Trip</h5>
                  <p>
                    {details.split("\\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>

                  {/*============= tour reviews section============*/}
                  {/* <div className="tour__reviews mt-4">
                    <h4>Reviews ({reviews?.length} reviews)</h4>

                    <Form onSubmit={submitHandler}>
                      <div className="d-flex align-items-center gap-3 mb-4 rating__group">
                        <span onClick={() => setTourRating(1)}>
                          <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(2)}>
                          <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(3)}>
                          <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(4)}>
                          <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(5)}>
                          <i class="ri-star-s-fill"></i>
                        </span>
                      </div>

                      <div className="review__input">
                        <input
                          type="text"
                          ref={reviewMsgRef}
                          placeholder="share your thoughts"
                          required
                        />
                        <button
                          className="btn primary__btn text-white"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </Form>

                    <ListGroup className="user__reviews">
                      {reviews?.map((review) => (
                        <div className="review__item">
                          <img src={avatar} alt="" />

                          <div className="w-100">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h5>Michael</h5>
                                <p>
                                  {new Date("10-08-2023").toLocaleDateString(
                                    "en-IN",
                                    options
                                  )}
                                </p>
                              </div>
                              <span className="d-flex align-items-center">
                                5 <i class="ri-star-s-fill"></i>
                              </span>
                            </div>
                            <h6>Amazing tour</h6>
                          </div>
                        </div>
                      ))}
                    </ListGroup>
                  </div> */}
                  <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
                  {/*============= tour reviews end============*/}
                </div>
              </div>
            </Col>
            <Col lg="4">
              <Booking tour={tour}  />
            </Col>
          </Row>
        </Container>
        
      </section>
      <Newsletter/>
    </>
  );
};

export default TourDetails;
